// src/roles.js
// Матрица доступа к разделам по ролям

export const ROLE_OPTIONS = [
    { id: 'user',        title: 'User' },
    { id: 'onlinegames', title: 'Onlinegames' },
    { id: 'studgames',   title: 'Studgames' },
    { id: 'coursespro',  title: 'Coursespro' },
    { id: 'pro',         title: 'PRO' },
    { id: 'admin',       title: 'Admin' },
  ];
  
  // Разделы в том же виде, как используются в App.js
  export const CATEGORIES = [
    'user',           // Игры в логистику
    'board',          // Настольные игры
    'rutube',         // Видео (RuTube)
    'online',         // Онлайн-игры
    'courses-stud',   // Курс: Логистика для школьников и студентов
    'courses-pro',    // Полезные материалы
    'plans',          // Тарифы
    'contacts',       // Контакты
  ];
  
  export const ROLE_MATRIX = {
    user: {
      allowed: ['user', 'board', 'rutube', 'courses-pro'],
    },
    onlinegames: {
      allowed: ['user', 'board', 'rutube', 'online', 'courses-pro'],
    },
    studgames: {
      allowed: ['user', 'board', 'rutube', 'courses-pro', 'courses-stud'],
    },
    coursespro: {
      allowed: ['user', 'board', 'rutube', 'courses-pro'],
    },
    pro: {
      // Все разделы
      allowed: [...CATEGORIES],
    },
    admin: {
      // Все разделы + админ возможности (переключение ролей)
      allowed: [...CATEGORIES],
    },
  };
  